import ModalProtocolsBrands from "./ModalProtocolsBrands";

export default ModalProtocolsBrands;